<template>
	<modal size="medium" class="modal-user-manual" @close="close" v-if="show">
		<div class="w-full" slot="header">
			<div class="d-flex justify-content-between w-full">
				<h3>{{ $t('User manuals') }}</h3>
			</div>
		</div>
		<div slot="body" class="p-0">

			<div
				class="list-file"
				v-if="items.length > 0">
				<div
					v-for="(item, index) in filteredItems"
					:key="index"
					class="file-item">
					<div class="clearfix">
						<div class="float-left d-flex file-item-left inline-item pointer">
							<div
								class="file-item-icon mr-2"
								@click="openInBrowser(item)">
								<i class="material-icons" style="color: #606060 !important;" v-if="item.category === 'video_url'">link</i>
								<i class="material-icons" style="color: #606060 !important;" v-else>attach_file</i>
							</div>
							<div
								class="file-item-name"
								@click="openInBrowser(item)">
								{{ item.name }} <span class="preview-text">({{ $t('preview') }})</span>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="empty-list" v-if="items.length === 0 && !isFetching">
				<div class="empty-list-icon">
					<i class="material-icons">description</i>
				</div>
				{{ $t('No user manuals available') }}
			</div>

			<div class="is-loading large p-5" v-if="isFetching"></div>
		</div>
		<div slot="footer">
			<div class="modal-actions clearfix">
				<div class="float-right">
					<button type="button" class="btn btn-lg btn-secondary btn-save raised" @click="close">
						{{ $t('close') }}
					</button>
				</div>
			</div>
		</div>
	</modal>
</template>

<script>
import { mapGetters } from 'vuex';

import participantApi from '@/api/participants';
import fileApi from '@/api/files';
import { duplicateVar } from '@/lib/helper';
import Modal from './Modal.vue';

export default {
	name: 'ModalUserManual',
	components: {
		Modal,
	},
	props: {
		show: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			isFetching: false,
			items: [],
			page: 1,
			limit: 25,
			orderBy: 'order',
			sortBy: 'asc',
			type: 'user_manual',
			participant: null,
		};
	},
	mounted() {
		this.fetchParticipantMe();
		this.fetch();
	},
	created() {},
	watch: {
	},
	computed: {
		...mapGetters({
			user: 'user',
			isSocketConnected: 'isSocketConnected',
		}),
		eventSlug() {
			return this.$route.params.eventSlug;
		},
		filteredItems() {
			const filtered = [];
			const items = duplicateVar(this.items);
			for (let index = 0; index < items.length; index++) {
				const item = items[index];

				if (!item.roles || item.roles.length === 0) {
					filtered.push(item);
				}

				// Check by participant roles
				if (this.participant && item.roles && item.roles.length > 0) {
					const articleRoles = item.roles;
					const participantRoles = this.participant.roles;

					for (let jndex = 0; jndex < participantRoles.length; jndex++) {
						const pRole = participantRoles[jndex];
						const isAdded = filtered.find(curr => curr.id === item.id);
						if (articleRoles.includes(pRole) && !isAdded) {
							filtered.push(item);
						}
					}
				}

				// Check by user role
				if (this.user && item.roles && item.roles.length > 0) {
					const articleRoles = item.roles;
					const userRole = this.user ? this.user.role : '';

					const isAdded = filtered.find(curr => curr.id === item.id);
					if (articleRoles.includes(userRole) && !isAdded) {
						filtered.push(item);
					}
				}
			}
			return filtered;
		},
	},
	methods: {
		close() {
			this.$emit('close');
		},
		fetch() {
			const params = {
				page: this.page,
				limit: this.limit,
				order_by: this.orderBy,
				sort_by: this.sortBy,
				type: this.type,
			};

			this.isFetching = true;
			const callback = (response) => {
				this.items = response.data;
				this.isFetching = false;
			};
			const errorCallback = (error) => {
				const message = error.response.data.message;
				this.$notify({
					group: 'foo-velocity',
					title: 'Error',
					text: message,
					type: 'error',
				});

				this.isFetching = false;
			};
			fileApi.getList(params, callback, errorCallback);
		},
		openInBrowser(item) {
			const path = item.category === 'file' ? item.path : item.video_url;
			window.open(path);
		},
		fetchParticipantMe() {
			if (!this.eventSlug) {
				this.participant = null;
				return;
			}
			const params = {
				event_slug: this.eventSlug,
			};
			participantApi.getMe(params, (response) => {
				const participant = response;
				const roles = participant.roles && typeof (participant.roles) === 'string' ? JSON.parse(participant.roles) : participant.roles;
				participant.roles = roles;
				this.participant = participant;
			}, () => {});
		},
	},
};
</script>
<style lang="scss">
</style>
